import { ConnectedCalendarResponseDTO } from '../../infra/adapters/luminara/calendar/dto/response/connected-calendar-response.dto';
import { HealerAvailabilityResponse } from '../../infra/adapters/luminara/calendar/dto/response/healer-availability-response.dto';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';
import { isNotFound } from '../../util/auth-util';

export const DEFAULT_AVAILABILITY: HealerAvailabilityResponse = {
  timezone: undefined,
  entries: [
    {
      day: 'MONDAY',
      workingHoursEntries: [],
      enabled: true,
    },
    {
      day: 'TUESDAY',
      workingHoursEntries: [],
      enabled: true,
    },
    {
      day: 'WEDNESDAY',
      workingHoursEntries: [],
      enabled: true,
    },
    {
      day: 'THURSDAY',
      workingHoursEntries: [],
      enabled: true,
    },
    {
      day: 'FRIDAY',
      workingHoursEntries: [],
      enabled: true,
    },
    {
      day: 'SATURDAY',
      workingHoursEntries: [],
      enabled: false,
    },
    {
      day: 'SUNDAY',
      workingHoursEntries: [],
      enabled: false,
    },
  ],
  bufferBetweenBookings: 0,
};

export interface HealerAvailabilityState {
  connectedCalendar?: ConnectedCalendarResponseDTO;
  availability: HealerAvailabilityResponse;
  calendarIntegrationErrors: string[];
  readMore: boolean;
  showSaveAvailabilityPopup: boolean;
  requestError?: string;
}

export const initialHealerAvailabilityState = () => {
  return {
    calendarIntegrationErrors: [],
    availability: DEFAULT_AVAILABILITY,
    readMore: false,
    showSaveAvailabilityPopup: false,
    requestError: '',
  } as HealerAvailabilityState;
};
export interface HealerAvailabilityAction {
  type:
    | 'CONNECTED_CALENDAR_LOAD_SUCCESS'
    | 'CONNECTED_CALENDAR_LOAD_FAILURE'
    | 'AVAILABILITY_LOAD_SUCCESS'
    | 'AVAILABILITY_LOAD_FAILURE'
    | 'SET_AVAILABILITY'
    | 'SET_TIMEZONE'
    | 'ADD_CALENDAR_INTEGRATION_ERROR'
    | 'SHOW_READ_MORE_SCREEN'
    | 'HIDE_READ_MORE_SCREEN'
    | 'SHOW_SAVE_AVAILABILITY_POPUP'
    | 'HIDE_SAVE_AVAILABILITY_POPUP'
    | 'REQUEST_ERROR'
    | 'HEALER_LOGGED_OUT'
    | 'SET_BUFFER_BETWEEN_BOOKINGS';
  payload?: any;
}

const healerAvailabilityReducer = (
  state: HealerAvailabilityState = initialHealerAvailabilityState(),
  action: HealerAvailabilityAction
): HealerAvailabilityState => {
  switch (action.type) {
    case 'CONNECTED_CALENDAR_LOAD_SUCCESS': {
      return { ...state, connectedCalendar: action.payload };
    }
    case 'CONNECTED_CALENDAR_LOAD_FAILURE': {
      if (isNotFound(action.payload)) {
        return { ...state, connectedCalendar: undefined };
      } else {
        return { ...state, calendarIntegrationErrors: state.calendarIntegrationErrors.concat(extractMessageFromError(action.payload)) };
      }
    }
    case 'SET_AVAILABILITY': {
      return { ...state, availability: { ...state.availability, entries: action.payload } };
    }
    case 'SET_TIMEZONE': {
      return { ...state, availability: { ...state.availability, timezone: action.payload } };
    }
    case 'AVAILABILITY_LOAD_SUCCESS': {
      return { ...state, availability: action.payload };
    }
    case 'AVAILABILITY_LOAD_FAILURE': {
      if (isNotFound(action.payload)) {
        return { ...state, availability: DEFAULT_AVAILABILITY };
      } else {
        return { ...state, calendarIntegrationErrors: state.calendarIntegrationErrors.concat(extractMessageFromError(action.payload)) };
      }
    }
    case 'ADD_CALENDAR_INTEGRATION_ERROR': {
      return { ...state, calendarIntegrationErrors: [...state.calendarIntegrationErrors, extractMessageFromError(action.payload)] };
    }
    case 'SHOW_READ_MORE_SCREEN': {
      return { ...state, readMore: true };
    }
    case 'HIDE_READ_MORE_SCREEN': {
      return { ...state, readMore: false };
    }
    case 'HIDE_SAVE_AVAILABILITY_POPUP': {
      return { ...state, showSaveAvailabilityPopup: false, requestError: undefined };
    }
    case 'SHOW_SAVE_AVAILABILITY_POPUP': {
      return { ...state, showSaveAvailabilityPopup: true };
    }
    case 'REQUEST_ERROR': {
      return { ...state, requestError: action.payload };
    }
    case 'HEALER_LOGGED_OUT': {
      return initialHealerAvailabilityState();
    }
    case 'SET_BUFFER_BETWEEN_BOOKINGS': {
      return { ...state, availability: { ...state.availability, bufferBetweenBookings: action.payload } };
    }
    default:
      return state;
  }
};

export default healerAvailabilityReducer;
